import { ProgramType } from 'fitbeat.models';
import { i18n } from '../../utils';

export const mappedTitles = {
  [ProgramType.GetLeanAndFitGoal]: i18n.t('workoutGoals:getLeanAndFit'),
  [ProgramType.GainMuscleAndStrengthGoal]: i18n.t('workoutGoals:gainMuscleAndStrength'),
  [ProgramType.GetStrongAndFitGoal]: i18n.t('workoutGoals:getStrongAndFit'),
  [ProgramType.MobilityAndTone]: i18n.t('workoutGoals:mobilityAndTone'),
  [ProgramType.MuscleAndShred]: i18n.t('workoutGoals:muscleAndShred'),
  [ProgramType.NotSet]: i18n.t('workoutGoals:notSet'),
};
